export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: '無料相談',
      description: 'まずはお気軽にご相談ください。秘密厳守でお話を伺います。',
      icon: 'ri-chat-smile-3-line'
    },
    {
      number: '02',
      title: '企業価値評価',
      description: '専門家が貴社の企業価値を適正に評価いたします。',
      icon: 'ri-line-chart-line'
    },
    {
      number: '03',
      title: 'マッチング',
      description: '豊富なネットワークから最適な相手先を選定します。',
      icon: 'ri-links-line'
    },
    {
      number: '04',
      title: 'トップ面談',
      description: '経営者同士の面談をセッティングいたします。',
      icon: 'ri-group-line'
    },
    {
      number: '05',
      title: '条件交渉',
      description: '専門家が間に入り、双方にとって最適な条件を調整します。',
      icon: 'ri-discuss-line'
    },
    {
      number: '06',
      title: '最終契約・成約',
      description: '契約書の作成から締結まで、全面的にサポートいたします。',
      icon: 'ri-file-check-line'
    }
  ];

  return (
    <section className="py-32 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5">
        <div className="absolute top-20 right-20 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <span className="text-teal-600 font-bold text-sm tracking-widest uppercase mb-4 block">
            Our Process
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            ご利用の流れ
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            初回相談から成約まで、専任担当者が一貫してサポートいたします
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-500"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className="group relative"
              >
                {/* Card */}
                <div className="relative bg-gradient-to-br from-slate-50 to-white rounded-3xl p-8 border-2 border-gray-200 hover:border-teal-500 transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 h-full">
                  {/* Number Badge */}
                  <div className="absolute -top-6 left-8 w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-12 transition-all duration-500">
                    <span className="text-white font-black text-lg">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-6 mt-8 shadow-md group-hover:shadow-xl transition-all duration-500 border border-gray-200">
                    <i className={`${step.icon} text-3xl text-teal-600`}></i>
                  </div>

                  <h3 className="text-2xl font-black text-gray-900 mb-4">
                    {step.title}
                  </h3>
                  
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {step.description}
                  </p>

                  {/* Decorative Corner */}
                  <div className="absolute bottom-0 right-0 w-20 h-20 bg-gradient-to-br from-teal-500/10 to-cyan-500/10 rounded-tl-full transition-all duration-500 group-hover:w-24 group-hover:h-24"></div>
                </div>

                {/* Arrow (Desktop) */}
                {index < steps.length - 1 && index % 3 !== 2 && (
                  <div className="hidden lg:block absolute top-24 -right-4 z-20">
                    <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-lg border-2 border-teal-500">
                      <i className="ri-arrow-right-line text-teal-600 text-lg"></i>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
